const SmallFieldGroup = ({ font }) => {
  const displayFact = () => {
    const funFacts = [
      "The M's in M&Ms stand for Mars and Murrie.",
      "'New car smell' is the scent of dozens of chemicals.",
      "Cotton candy was invented by a dentist.",
      "Chewing gum boosts concentration.",
      "Space smells like seared steak.",
      "Bees sometimes sting other bees.",
      "Vatican City is the smallest country in the world",
      "The original name for the search engine Google was Backrub.",
      "Octopuses have three hearts.",
      "The earth’s circumference is 24,900 miles."
    ];
    const randomFactIndex = Math.floor(Math.random() * funFacts.length);
    alert("Random Fact: " + funFacts[randomFactIndex]);
  };

  return (
    <div
      className="bg-grey-50 p-4 rounded-sm"
      style={{ fontFamily: `${font.fonts}` }}
    >
      <span className="label-1">
        <strong>Font:</strong> {font.type}
      </span>
      <p className="mt-3">I am a paragraph</p>
      <div className="mt-3">
        <span className="label-2"> I am some emoji's </span>
        <p>❤️🙂🍟🍔🍜🍺😇👋🍍🦄</p>
      </div>

      <button className="btn mt-4" onClick={(e) => displayFact(e)}>
        Don't click
      </button>
    </div>
  );
};

export default SmallFieldGroup;
